import { Card, CardContent, CardHeader, Divider } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import { Theme } from '@mui/material/styles';
import TextField from '@mui/material/TextField';
import * as React from 'react';
import { makeStyles } from 'tss-react/mui';
import useAsyncModifySettings from '../../../hooks/useAsyncModifySettings';
import { TimeZoneSettings } from '../../../sic-lib/types/GeneralSettings';
import { buildUpdateSettings } from '../../../sic-lib/types/Settings';
import { useAppDispatch } from '../../../store/hooks';
import { updateTimeZone } from '../../../store/users';

const useStyles = makeStyles()((theme: Theme) => ({}));

interface Props {
    timeZone: [TimeZoneSettings];
}

export default function GeneralSettings({ timeZone }: Props) {
    const { classes } = useStyles();
    const dispatch = useAppDispatch();

    const { requestStatus, asyncModifySettings } = useAsyncModifySettings();

    const [time, setTime] = React.useState('');

    const handleSelect = async (event: React.ChangeEvent<HTMLInputElement>) => {
        setTime(event.target.value);
        const timeZoneId = buildUpdateSettings({
            name: 'TimeZoneId',
            value: event.target.value,
        });
        const data = [timeZoneId];

        const asyncResult = await asyncModifySettings(data);

        if (asyncResult) {
            await dispatch(updateTimeZone(event.target.value));
            console.log('asyncRes', asyncResult);
        }
    };

    React.useEffect(() => {
        if (timeZone && timeZone[0]?.value) setTime(timeZone[0].value);
    }, [timeZone]);

    return (
        <Card>
            <CardHeader title="General Settings" />
            <Divider />
            <CardContent>
                <TextField
                    select
                    value={time}
                    id="select_user"
                    label="Time Zone"
                    onChange={handleSelect}
                    fullWidth
                >
                    {timeZone[0].options.map(itm => (
                        <MenuItem key={itm.value} value={itm.value}>
                            {itm.name}
                        </MenuItem>
                    ))}
                </TextField>
            </CardContent>
        </Card>
    );
}
